import { ProjectDetailsFieldType, ProjectType } from './Types';
import { useBackendApi } from './backendApi';
import { useEventsPublisher } from 'event-bus';

export enum FubFieldType {
  TEXT = 'text',
  NUMBER = 'number',
  DATE = 'date',
  DROPDOWN = 'dropdown',
}

export interface FubFieldMapEntry {
  fubFieldId: string;
  fubFieldLabel: string;
  fubFieldType: FubFieldType;
  fubFieldAlias: string;
  nekstFieldId?: string;
  nekstFieldLabel: string | null;
  nekstFieldType: ProjectDetailsFieldType | null;
  _setupArea: {
    id: number,
  }
}

export interface UpdateFubFieldMapRequest {
  nekstFieldId?: string;
}


export interface UpdateEntriesRequest {
  entries: {
    setupAreaId: number,
    fubFieldId: string
    nekstFieldId?: string
  }[]
}

export const FUB_FIELDS_MAP_UPDATED = 'FUB_FIELDS_MAP_UPDATED';

export function useFubFieldsMappingService() {
  const nekstApi = useBackendApi();
  const eventsPublisher = useEventsPublisher();

  /**
   * Get all field mapping entries
   */
  const getAllEntries = async (profileId: number, projectType: ProjectType): Promise<FubFieldMapEntry[]> => {
    return await nekstApi.get(`/integrations/profiles/${profileId}/fub/fieldsmapping/${projectType.toLowerCase()}`) as FubFieldMapEntry[];
  };

  /**
   * Update field mapping entry
   */
  const updateEntry = async (
    profileId: number,
    fubFieldId: string,
    projectType: ProjectType,
    request: UpdateFubFieldMapRequest
  ): Promise<void> => {
    await nekstApi.put(
      `/integrations/profiles/${profileId}/fub/fieldsmapping/${projectType.toLowerCase()}/${fubFieldId}`,
      {
        nekstFieldId: request.nekstFieldId
      }
    );

    eventsPublisher.publish(FUB_FIELDS_MAP_UPDATED, {});
  };


  const updateMapEntries = async (
    profileId: number,
    projectType: ProjectType,
    entries: {
      setupAreaId: number,
      fubFieldId: string
      nekstFieldId?: string
    }[]
  ) =>  {
    await nekstApi.put(
      `/integrations/profiles/${profileId}/fub/fieldsmapping/${projectType.toLowerCase()}/entries`,
      {
        entries,
      }
    );

    eventsPublisher.publish(FUB_FIELDS_MAP_UPDATED, {});
  };


  return {
    getAllEntries,
    updateEntry,
    updateMapEntries,
  };
}
